import { inject, Injectable } from '@angular/core';
import { PublicRestService, PublicSablonyFiltrDto, PublicSablonyVysledekDto } from '@generated/be';
import { BrowseStateService, DEFAULT_PAGE_LIMIT, publicApiArgs } from '@shared/utils';
import { Observable } from 'rxjs';

/** Veřejný katalog šablon: stav přehledu (filtr + stránkovaný výsledek), bez řazení. */
@Injectable()
export class SeznamSablonStateService extends BrowseStateService<PublicSablonyFiltrDto, PublicSablonyVysledekDto> {
  private readonly publicRestService = inject(PublicRestService);

  protected override readonly pagingMode = 'list';
  protected readonly defaultFilter: PublicSablonyFiltrDto = {
    pageAndSortList: { start: 0, count: DEFAULT_PAGE_LIMIT, sortListPage: [] },
  };
  protected readonly emptyResult: PublicSablonyVysledekDto = { total: 0, content: [] };

  constructor() {
    super();
    this.initBrowse();
  }

  protected search(filter: PublicSablonyFiltrDto): Observable<PublicSablonyVysledekDto> {
    return this.publicRestService.vyhledatPublicSablony({ publicSablonyFiltrDto: filter }, ...publicApiArgs());
  }

  /** Našeptávače gestora a názvu vrací objekt; do filtru BE jde jen kód / název. */
  protected override adjustFilter(filter: Partial<PublicSablonyFiltrDto>): Partial<PublicSablonyFiltrDto> {
    const value = filter as Record<string, unknown>;
    const gestor = value['gestor'] as { kod?: string } | string | undefined;
    const nazev = value['nazev'] as { nazev?: string } | string | undefined;
    return {
      ...filter,
      ...(typeof gestor === 'object' && gestor?.kod ? { gestor: gestor.kod } : {}),
      ...(typeof nazev === 'object' && nazev?.nazev ? { nazev: nazev.nazev } : {}),
    };
  }
}
